export const pluralize = (word: string, count: number = 0): string => {
  return count <= 1 ? word : `${word}s`;
};

export const splitText = (
  text: string | undefined | null,
  limit: number = 30
) => {
  if (!text) return;
  return text.length > limit ? text.slice(0, limit) + "…" : text;
};

export const capitalize = (str: string | null) =>
  str && (str.charAt(0).toUpperCase() + str.slice(1)).replace(/-/g, " ");

export const arrayMove = (
  array: any[],
  oldValue: any,
  condition: "plus" | "minus"
): any[] => {
  const indexOldValue = array.indexOf(oldValue);

  if (indexOldValue === -1 || (indexOldValue === 0 && condition === "minus")) {
    return array;
  }

  const newArray = [...array];
  newArray[indexOldValue] =
    newArray[condition === "plus" ? indexOldValue + 1 : indexOldValue - 1];
  newArray[condition === "plus" ? indexOldValue + 1 : indexOldValue - 1] =
    oldValue;

  return newArray;
};

export const createMarkup = (html: string) => ({ __html: html });

export const removeUndefined = (text: string) => {
  return text
    .split(" / ")
    .filter((segment) => segment !== "undefined")
    .join(" / ");
};
